export default [
    {
        paymentId:'pay_G11ZY646x6Afk3',
        amount:599,
        email:'abc@gmail.com',
        contact:'+919876543210',
        time: new Date(2021,11,1,11,10,12),
        status:'captured'
    },
    {
        paymentId:'pay_G11ZY646x6Afk4',
        amount:299,
        email:'xyz@gmail.com',
        contact:'+919876543510',
        time: new Date(2021,10,28,11,10,12),
        status:"captured"
    },
    {
        paymentId:'pay_G11ZY646x6Afk3',
        amount:599,
        email:'abc@gmail.com',
        contact:'+919876543210',
        time: new Date(2021,10,15,11,10,12),
        status:"failed"
    },
    {
        paymentId:'pay_G11ZYdf6x6Afk3',
        amount:549,
        email:'aadfc@gmail.com',
        contact:'+919876553210',
        time: new Date(2021,10,10,11,10,12),
        status:'captured'
    },
    {
        paymentId:'pay_G11Zdfd6x6Afk3',
        amount:299,
        email:'cjd@gmail.com',
        contact:'+911586543210',
        time: new Date(2021,9,1,11,10,12),
        status:'captured'
    },
    {
        paymentId:'pay_GfdaZY646x6Afk3',
        amount:199,
        email:'jkl@gmail.com',
        contact:'+919156543210',
        time: new Date(2021,6,1,11,10,12),
        status:'captured'
    },
    {
        paymentId:'pay_G1dfa646x6Afk3',
        amount:999,
        email:'pqr@gmail.com',
        contact:'+916976543210',
        time: new Date(2021,5,1,11,10,12),
        status:'failed'
    },
    {
        paymentId:'pay_G11ZY4986x6Afk3',
        amount:599,
        email:'klm@gmail.com',
        contact:'+915876543210',
        time: new Date(2021,4,1,11,10,12),
        status:'captured'
    }
]